import { createStore } from '../../modules/Store';

const updateState = (currentState, patch) => {
  const updatedState = { ...currentState, ...patch };
  if (process.env.REACT_APP_CHANNEL === 'prod') return updatedState;
  console.groupCollapsed('Action');
  console.log('%cprevState', 'color:#2E8B57; font-size:14px;', currentState);
  console.log('%cnextState', 'color:#FF6347; font-size:14px;', updatedState);
  console.groupEnd();
  return updatedState;
};
export { createStore, updateState };
export default {};
